import { schema } from 'normalizr';

const OrderSaleSchema = new schema.Entity('orderSales', {});
const OrderSaleItemSchema = new schema.Entity('orderSales', {});
const ContactSchema = new schema.Entity('contacts', {});
const AddressSchema = new schema.Entity('addresses', {});
const ShippingTypeSchema = new schema.Entity('shippingTypes', {});

export { ContactSchema, AddressSchema, OrderSaleSchema, OrderSaleItemSchema, ShippingTypeSchema };
